import React from 'react';
import HomePage from '../homePage/homePage';

const NotFound = () => {
    return <HomePage warning="not_found_warning" />;
};

export default NotFound;
